import { render, staticRenderFns } from "./Faltas.vue?vue&type=template&id=723c93df"
import script from "./Faltas.vue?vue&type=script&lang=ts"
export * from "./Faltas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports